import { Component, input } from '@angular/core';
import { DomainComponent } from '../../domain/domain.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  imports: [DomainComponent, NgIf],
})
export class LoaderComponent {
  error = input.required<boolean>();
}
